/**
 * Página 404 para rutas no encontradas. Muestra mensaje con botón para volver al inicio.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import notFoundSvg from "assets/404.svg";
import { Button, Typography, Image } from "antd";
import "views/notFound/index.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="app-container">
      <div className="main-content">
        <div className="not-found-wrapper">
          <Image src={notFoundSvg} preview={false} width={350} />
          <div className="bottom-wrapper">
            <Typography.Title level={5}>La página solicitada no existe.</Typography.Title>
            <Button type="primary" onClick={() => navigate("/")} size="large">
              Volver
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
